export enum AdvanceSearchProperties {
    None = 0,
    Comments = 1,
    Description = 2,
    ApplicableOn = 4,
    Objective = 8,
    Method = 16,
    ParameterCode = 32,
    ParameterName = 64,
    CASNumber = 128,
}
